module.exports = __webpack_public_path__ + "4b65e4c469eb0c5542b37c77178234de.MP3";